module.exports = __webpack_public_path__ + "img/list02.3c16f0ff.png";